import React from "react";
import { useAuth } from "../provider/Authprovider";
import { Navigate, useLocation } from "react-router-dom";

const Authentication = ({ children }) => {
    const {isLoggedIn } = useAuth();
    const location = useLocation();
    
    if (!isLoggedIn()) {
        return <Navigate to="/dss/login" state={{ path: location.pathname }} />;
    }
    return children;
};
export default Authentication;